module.exports = __webpack_public_path__ + "static/media/Collection-In-villa-experiences-Mobile.8533f49d.webp";